import React from 'react';
import styled, { css } from 'styled-components';

import { stylesFor, zIndexFor } from '../styles/utilities';
import Tile from './tile';

const defaultTileHeight = 300;
const defaultRows = 3;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  overflow: visible;

  ${stylesFor.smallUp`
    flex-wrap: wrap;
    height: ${props =>
      props.mediumRows
        ? props.mediumRows * defaultTileHeight
        : defaultTileHeight * defaultRows}px;
  `};

  ${stylesFor.xLargeUp`
    height: ${props =>
      props.largeRows
        ? props.largeRows * defaultTileHeight + 1
        : defaultTileHeight * defaultRows + 1}px;
  `};
`;

const Container = styled.div`
  position: relative;

  ${stylesFor.smallUp`
    height: ${props =>
      props.rowSpan ? defaultTileHeight * props.rowSpan : defaultTileHeight}px;
    transition: transform 0.1s linear, box-shadow 0.2s linear;
    width: 50%;
  `};

  ${stylesFor.xLargeUp`
    width: 33.333%;
  `};
`;

const GridTile = styled(Tile)`
  && {
    background-color: transparent;
    height: 100%;
    z-index: ${zIndexFor('TileGrid')};

    ${Container}:hover & {
      z-index: ${zIndexFor('TileGrid') + 1};
    }
  }
`;

const Background = styled.div`
  background-color: ${props => props.theme.color.white};
  bottom: 0;
  left: 0;
  outline: 1px solid ${props => props.theme.color.gray92};
  position: absolute;
  right: 0;
  top: 0;
  transition: all 0.1s linear;

  ${props =>
    props.image
      ? css`
        background-image: linear-gradient(40deg, white 55%, rgba(255,255,255,0.45)), url('${
          props.image
        }');
        background-size: cover;
      `
      : ''};

  ${Container}:hover & {
    box-shadow: ${props => props.theme.shadow.standard};
    left: -12px;
    top: -12px;
    right: -12px;
    bottom: -12px;
    z-index: ${zIndexFor('TileGrid')};
  }
`;

export default ({ tiles, mediumRows, largeRows, className }) => {
  return (
    <Root mediumRows={mediumRows} largeRows={largeRows} className={className}>
      {tiles.map(tile => (
        <Container key={tile.title} rowSpan={tile.rowSpan}>
          <GridTile
            title={tile.title}
            description={tile.description}
            linkText={tile.linkText}
            linkTarget={tile.linkTarget}
          />
          <Background image={tile.backgroundImage} />
        </Container>
      ))}
    </Root>
  );
};



// WEBPACK FOOTER //
// ./src/components/tileGrid.js